import React from 'react';
import igArtifactMob from '../../assets/images/instgram_mob.png';
import ytArtifactMob from '../../assets/images/youtube_mob.png';
import spotifyArtifactMob from '../../assets/images/spotify_mob.png';
import { CircleCheck } from 'lucide-react';

const MusicMarketing = ({id}) => {
  const handleMusicMarketingClick = () => {
    window.location.href = '/music-marketing'
  };
  return (
    <div id={id} className="min-h-screen bg-black text-white font-sans scroll-mt-24">
      {/* Header */}
      <div className="text-center ">
        <h1 className="text-3xl md:text-5xl py-10 md:py-0 lg:text-5xl font-normal tracking-widest text-white px-4 font-inter relative z-10">
          MUSIC MARKETING
        </h1>
      </div>

      {/* Spotify Section */}
      <div className="py-12 md:py-20 bg-black">
        <div className="max-w-7xl mx-auto px-4 md:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-12 items-center">
            {/* Text Content */}
            <div className="space-y-4 md:space-y-6 order-2 lg:order-1">
              <h2 className="text-2xl md:text-3xl lg:text-4xl font-normal leading-tight">
                SPOTIFY<br/>
                MUSIC STRATEGY
              </h2>
              
              <p className="text-white-300 text-[16px] md:text-lg">
                We pitch your song to curated UGC playlists that trigger the algorithm organically.
              </p>
              
              <div className="space-y-3">
                <div className="flex items-center gap-3 !mt-[22px]">
                  <div className="w-6 h-6  flex items-center justify-center flex-shrink-0">
                    <CircleCheck className='text-green-500'/>
                  </div>
                  <span className="text-white-400 text-[18px] md:text-[20px] ">Playlist pitching</span>
                </div>
                <div className="flex items-center gap-3 !mt-[22px]">
                  <div className="w-6 h-6  flex items-center justify-center flex-shrink-0">
                    <CircleCheck className='text-green-500'/>
                  </div>
                  <span className="text-white-400 text-[18px] md:text-[20px] ">Bot-filtered curation</span>
                </div>
                <div className="flex items-center gap-3 !mt-[22px]">
                  <div className="w-6 h-6  flex items-center justify-center flex-shrink-0">
                    <CircleCheck className='text-green-500'/>
                  </div>
                  <span className="text-white-400 text-[18px] md:text-[20px] ">Save rate optimization</span>
                </div>
              </div>
              
              <button onClick={handleMusicMarketingClick} className="bg-green-500 hover:bg-green-600 text-white font-normal py-[16px] px-[28px] rounded-xl transition-colors duration-300 text-[14px] md:text-[16px]   !mt-[46px]">
                View Our Marketing Approach
              </button>
            </div>
            
            {/* Image */}
            <div className="flex justify-center order-1 lg:order-2">
              <div className="w-full max-w-sm md:max-w-none">
                {/* Mobile Image */}
                <img 
                  src={spotifyArtifactMob}
                  alt="Spotify Marketing"
                  className="w-full h-auto object-cover rounded-lg md:hidden"
                />
                {/* Desktop Image */}
                <img 
                  src="https://rummy-assets.jungleerummy.com/Content/versioned/2.0.0.1/images/version4/promotion_june_25/zenrik_images/musicdistribution-service-(1)-17512237066265.webp?v=1751223708"
                  alt="Spotify Marketing"
                  className="w-full h-auto object-cover rounded-lg hidden md:block"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* YouTube Section */}
      <div className="py-12 md:py-20">
        <div className="max-w-7xl mx-auto px-4 md:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-12 items-center">
            {/* Image */}
            <div className="flex justify-center order-1">
              <div className="w-full max-w-sm md:max-w-none">
                {/* Mobile Image */}
                <img 
                  src={ytArtifactMob}
                  alt="YouTube Marketing"
                  className="w-full h-auto object-cover rounded-lg md:hidden"
                />
                {/* Desktop Image */}
                <img 
                  src={ytArtifactMob}
                  alt="YouTube Marketing"
                  className="w-full h-auto object-cover rounded-lg hidden md:block md:mt-[-100px]"
                />
              </div>
            </div>
            
            {/* Text Content */}
            <div className="space-y-4 md:space-y-6 order-2">
              <h2 className="text-2xl md:text-3xl lg:text-4xl font-normal leading-tight">
                YOUTUBE<br/>
                ADS STRATEGY
              </h2>
              
              <p className="text-white-300 text-[16px] md:text-[20px]">
                Promote your song to the right audience using discovery-based, highly engaging Youtube Campaigns.
              </p>
              
              <div className="space-y-3">
                <div className="flex items-center gap-3 !mt-[26px]">
                 <div className="w-6 h-6  flex items-center justify-center flex-shrink-0">
                    <CircleCheck className='text-red-500'/>
                  </div>
                   
                  <span className="text-white-400 text-[18px] md:text-[20px] ">Smart targeting by region & interest</span>
                </div>
                <div className="flex items-center gap-3 !mt-[26px]">
                <div className="w-6 h-6  flex items-center justify-center flex-shrink-0">
                    <CircleCheck className='text-red-500'/>
                  </div>
                  <span className="text-white-400 text-[18px] md:text-[20px] ">Low CPV, high retention optimization</span>
                </div>
                <div className="flex items-center gap-3 !mt-[26px]">
                  <div className="w-6 h-6  flex items-center justify-center flex-shrink-0">
                    <CircleCheck className='text-red-500'/>
                  </div>
                  <span className="text-white-400 text-[18px] md:text-[20px] ">Designed for discovery, not interruption</span>
                </div>
              </div>
              
              <button onClick={handleMusicMarketingClick} className="bg-red-600 hover:bg-red-700 text-white py-[16px] px-[28px] rounded-xl transition-colors duration-300 text-[14px] md:text-[16px]   font-normal   !mt-[48px]">
                View Our Marketing Approach
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Instagram Section */}
      <div className="py-12 md:py-20 bg-black">
        <div className="max-w-7xl mx-auto px-4 md:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-12 items-center">
            {/* Text Content */}
            <div className="space-y-4 md:space-y-6 order-2 lg:order-1">
              <h2 className="text-2xl md:text-3xl lg:text-4xl font-normal leading-tight">
                INSTAGRAM<br/>
               CONTENT MARKETING
              </h2>
              
              <p className="text-white-300 text-[16px] md:text-lg">
                With targeted Instagram marketing, we can ensure your song trends and reaches millions.
              </p>
              
              <div className="space-y-3">
                <div className="flex items-center gap-3 !mt-[26px]">
                     <div className="w-6 h-6  flex items-center justify-center flex-shrink-0">
                    <CircleCheck className='text-[#D1298E]'/>
                  </div>
               
                  <span className="text-white-400 text-[18px] md:text-[20px] ">Gain exposure to popular pages and creators</span>
                </div>
                <div className="flex items-center gap-3 !mt-[26px]">
                    <div className="w-6 h-6  flex items-center justify-center flex-shrink-0">
                    <CircleCheck className='text-[#D1298E]'/>
                  </div>
                  <span className="text-white-400 text-[18px] md:text-[20px] ">Boost engagement and discoverability</span>
                </div>
                <div className="flex items-center gap-3 !mt-[26px]">
                    <div className="w-6 h-6  flex items-center justify-center flex-shrink-0">
                    <CircleCheck className='text-[#D1298E]'/>
                  </div>
                  <span className="text-white-400 text-[18px] md:text-[20px] ">Grow your music effectively</span>
                </div>
              </div>
              
            <button onClick={handleMusicMarketingClick} className="bg-[#D1298E] text-white font-normal py-[16px] px-[28px] rounded-xl transition-all duration-300 text-[14px] md:text-[16px]  !mt-[48px]">
 
                View Our Marketing Approach
              </button>
            </div>
            
            {/* Image */}
            <div className="flex justify-center order-1 lg:order-2">
              <div className="w-full max-w-sm md:max-w-none">
                {/* Mobile Image */}
                <img
                  src={igArtifactMob}
                  alt="Instagram Marketing"
                  className="w-full h-auto object-cover rounded-lg md:hidden"
                />
                {/* Desktop Image */}
                <img
                  src="https://rummy-assets.jungleerummy.com/Content/versioned/2.0.0.1/images/version4/promotion_june_25/zenrik_images/musicdistribution-service-(1)2-17512236978676.webp?v=1751223699"
                  alt="Instagram Marketing"
                  className="w-full h-auto object-cover rounded-lg hidden md:block"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      
    </div>
  );
};

export default MusicMarketing;